var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.designType,{tag:"component",attrs:{"sp-class":_vm.spClass,"icon":_vm.icon,"icon-height":_vm.smallIconHeight,"icon-width":_vm.smallIconWidth,"text":_vm.text,"text-transform":_vm.textTransform,"small-text":_vm.smallText,"loading":_vm.loading,"disabled":_vm.disabled}})
}
var staticRenderFns = []

export { render, staticRenderFns }